import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import { cn } from "@tine/designsystem-utils";
import type { ContentfulImageWithFocus } from "../../../common/types/cmsTypes";
import ImageWithFocus from "../ImageWithFocus";
import { type ArticleProps, prefaceFont } from "./Article";
import PublishDate from "./PublishDate";

const LargeImageArticleHeader = ({ article, id }: ArticleProps) => {
   const inspectorProps = useContentfulInspectorMode();
   const headerImage = (article.fields.headerImage as ContentfulImageWithFocus) || undefined;
   const { title, preface } = article.fields;

   const headerBoxPaddingStyle = "px-4 md:px-20 pt-4 lg:pt-8 pb-4 lg:pb-12";
   const headerBoxPlacementStyle = "relative z-10 mx-auto max-w-4xl -mt-8 md:-mt-24";
   const headerBoxContentStyle =
      "flex flex-col items-center justify-center gap-4 sm:gap-8 text-center bg-surface-tinted rounded-lg";

   return (
      <div className="mb-8">
         <div className="w-full">
            {headerImage && (
               <div>
                  <ImageWithFocus
                     width={1250}
                     ratio="21x9"
                     key={JSON.stringify(headerImage)}
                     entryId={headerImage.sys.id}
                     placement="aboveFold"
                     className="object-cover rounded-md"
                     {...inspectorProps({
                        entryId: id,
                        fieldId: "headerImage"
                     })}
                     imageFromParent={headerImage}
                  />
               </div>
            )}

            <div className="px-3">
               <div className={cn(headerBoxContentStyle, headerBoxPaddingStyle, headerBoxPlacementStyle)}>
                  <h1
                     className="mt-2 mb-0 text-3xl font-bold text-blue-900 lg:text-4xl"
                     {...inspectorProps({
                        entryId: id,
                        fieldId: "title"
                     })}
                  >
                     {title}
                  </h1>
                  <p
                     className={cn(prefaceFont, "mb-0")}
                     {...inspectorProps({
                        entryId: id,
                        fieldId: "preface"
                     })}
                  >
                     {preface}
                  </p>
                  <PublishDate createdAt={article.sys.createdAt} updatedAt={article.sys.updatedAt} />
               </div>
            </div>
         </div>
      </div>
   );
};

export default LargeImageArticleHeader;
